<div class="language-switch" [class.light]="theme == 'light'">
  <img src="assets/flag/flag-ukr.svg" alt="Ukrainian Flag" class="flag"
       (click)="switchLanguage('uk')"
       matTooltip="Ukrainian"
       i18n-matTooltip="Navigation|Ukrainian language title@@navigation-ukrainian-language-title"/>

  <div class="separator">|</div>

  <img src="assets/flag/flag-usa.svg" alt="USA Flag" class="flag"
       (click)="switchLanguage('en')"
       matTooltip="English"
       i18n-matTooltip="Navigation|English language title@@navigation-english-language-title"/>
</div>
